import React from "react";
import { graphql } from "gatsby";
import SEO from "../../components/SEO/SEO";
import Layout from "../../components/Layout/Layout";
import FlexibleLayout from "../../components/FlexibleLayout";

export default ({ data, location, pageContext }) => {
  const { page } = data;
  const { flexibleLayout, seo } = page;

  return (
    <>
      <SEO seoData={seo} uri={page.uri} />
      <Layout bodyClass={page.slug} pageContext={pageContext} location={location}>
        {flexibleLayout?.flexibleChildren &&
          flexibleLayout?.flexibleChildren.map((layout, index) => {
            return <FlexibleLayout key={index} layout={layout} pageContext={pageContext} />;
          })}
      </Layout>
    </>
  );
};

export const query = graphql`
  query page($databaseId: Int!) {
    page: wpPage(databaseId: { eq: $databaseId }) {
      ...PageContent
    }
  }
`;

export const fragments = graphql`
  fragment PageContent on WpPage {
    title
    content
    databaseId
    uri
    dateGmt
    modifiedGmt
    slug
    seo {
      ...SeoData
    }
    flexibleLayout {
      flexibleChildren {
        __typename
        ...ApproachCards
        ...Hero
        ...SolutionCards
        ...PageHeader
        ...OurPartners
        ...LeadershipCards
        ...FeaturedLeadership
        ...HeroSimple
        ...HeroCta
        ...CtaScroll
        ...ContactForm
        ...FeaturedList
        ...Statement
        ...Summary
        ...Details
        ...FeaturedGrid
        ...RelatedItems
        ...Quote
        ...Overview
        ...StackedImages
        ...GridCard
      }
    }
  }
`;
